
import Vue, { PropType } from 'vue';
import { MenuItem } from './menu-item';

export default Vue.extend({
    props: {
        title: {
            type: String as PropType<string>,
            default: ''
        },

        items: {
            type: Array as PropType<MenuItem[]>,
            default: () => ([])
        },

        selected: {
            type: Object as PropType<MenuItem>,
            default: () => ({})
        }
    },

    methods: {
        onItemSelected(item: MenuItem): void {
            this.$emit('select', item);
        }
    }
});
